import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Devider from "./Devider";
import SummaryAPI from "../Commson/summaryApi";
import Axios from "../Utils/axios";
import { logout } from "../Store/Userslice";
import { AxiosToastError } from "../Utils/AxiosToastError";
import toast from "react-hot-toast";
import { HiOutlineExternalLink } from "react-icons/hi";
import isAdmin from "../Utils/isAdmin";

const Usermenu = () => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await Axios({
        ...SummaryAPI.logout,
        withCredentials: true, // Important for cookie-based auth
      });

      if (response.data.success) {
        dispatch(logout());
        toast.success(response.data.message);
        navigate("/login");
      }
    } catch (err) {
      // Even if API call fails, logout locally
      dispatch(logout());
      toast.error("Logged out successfully");
      navigate("/login");
    }
  };

  // Safe check for user data
  if (!user?._id) {
    return <div>Loading...</div>;
  }

  const isUserAdmin = isAdmin(user?.role);

  return (
    <div className="p-5 bg-white rounded-xl space-y-5 ">
      {/* Header */}
      <div>
        <h2 className="text-xl font-bold text-gray-800">My Account</h2>
        <div className="flex items-center gap-2 text-gray-600 text-base mt-2">
          <span className="font-medium truncate">
            {user?.name}
            <span className="ml-1 text-sm">
              ({user.role === "admin" ? "ADMIN" : "USER"})
            </span>
          </span>
          <Link
            to={"/dashboard/profile"}
            className="text-orange-500 hover:text-orange-600 transition"
          >
            <HiOutlineExternalLink size={20} />
          </Link>
        </div>
      </div>

      <Devider />

      {/* Menu */}
      <div className="grid gap-2 text-base">
        {/* Common menu items for all users */}
        <Link
          to={"/dashboard/cco"}
          className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
        >
          Cabinet Order
        </Link>

        <Link
          to={"/dashboard/Saveorder"}
          className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
        >
          Save Order
        </Link>

        {/* Admin-only menu items */}
        {isUserAdmin && (
          <>
            <Link
              to={"/dashboard/ragister"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Register
            </Link>

            <Link 
              to="/dashboard/appointments" 
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Appointments
            </Link>

            <Link 
              to="/dashboard/appointment-management" 
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Appointment Analytics
            </Link>

            <Link
              to={"/dashboard/AdminUserManagement"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              User Management
            </Link>

            {/* Commented out admin options - uncomment if needed */}
            {/* 
            <Link
              to={"/dashboard/category"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Category
            </Link>

            <Link
              to={"/dashboard/subcategory"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Sub Category
            </Link>

            <Link
              to={"/dashboard/uploadproduct"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Upload Product
            </Link>

            <Link
              to={"/dashboard/product"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Product
            </Link>

            <Link
              to={"/dashboard/myorder"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              My Orders
            </Link>

            <Link
              to={"/dashboard/adress"}
              className="px-3 py-2 rounded-md hover:bg-orange-100 hover:text-orange-600 transition font-medium block"
            >
              Addresses
            </Link>
            */}
          </>
        )}

        {/* Logout button for all users */}
        <button
          onClick={handleLogout}
          className="px-3 py-2 rounded-md text-red-500 hover:bg-red-100 transition font-medium text-left w-full"
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Usermenu;